import React from 'react';
import {Col, Divider, Row, Typography, Image, Skeleton, Spin, Button, Popconfirm} from "antd";
import {track} from "@amplitude/analytics-browser";
import {logout} from "../../tools/firebase";

const { Title, Text } = Typography;

const SourcePanel = ({selectedSource, onSourceClick, selectedResult, onDeleteClicked}) => {
    return (
        <div>
            <Title
                level={4}
                style={{marginTop: 16, marginBottom: 16, marginLeft: 16, float: "left"}}
            >
                Source
            </Title>
            <Popconfirm
                title="Are you sure？"
                okText="Yes"
                cancelText="No"
                onConfirm={() => {
                    track("delete_results_clicked");
                    onDeleteClicked(selectedSource.url);
                }}
                onCancel={ () => {}}
            >
                <Button type="primary" danger style={{
                    marginTop: 16, marginBottom: 16, marginRight: 16, float: "right", height: 40, borderRadius: 8
                }}>
                    Delete all results
                </Button>
            </Popconfirm>
            <Divider />
            <Row>
                <div style={{width: "512px", margin: "0 auto"}}>
                    <Image
                        key={selectedSource.url}
                        src={selectedSource.url}
                        preview={false}
                        style={{
                            marginTop: 24,
                            marginBottom: 24,
                            outline: selectedResult.hasOwnProperty("url") ? "none" : "4px solid #1890FF",
                            outlineOffset: "4px"
                        }}
                        placeholder={
                            <Spin style={{marginTop: 4}}/>
                        }
                        onClick={onSourceClick}
                    />
                </div>
            </Row>
        </div>
    );
};

export default SourcePanel;